module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Language to Live In")]), _vm._v(" "), _c('p', {
    staticClass: "E-pigraph-source-space"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For Janet and Peter Brav")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Codes everywhere clamoring to be cracked.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Crack ’em and you get oozes of –"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("isms")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Lubricated by lies bought and paid for.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Men live in armories they call their homes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As likely to kill their wives and children")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As the men they believe would do it first,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Hate cancered in so far pain’s a habit")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("No drug can soothe withdrawal from—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Murder makes sense (no language to live in).")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Those who buy their way out of suffering")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Never go as far as they think they will.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The distance trivializes light-years.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The unbearable truth: the only way out")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Is within—there’s no place else to go.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Once religion guided believers there,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("But then Toto ran behind the curtain,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And people finally got it: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("man’s best friend")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("(Of whom the sad ex-pat Christian incanted,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("‘Oh, keep the Dog far hence, that’s friend to men,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Or with his nails he’ll dig it up again!’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Lines so easy to forget and let go to waste).")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The dog, primitive cultures tell, teaches men")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("How to be human. Just another code?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Sure, but so simple it bears examining.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The animal comes first. Born of a female,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Issue of sex, sweeter than sin (Cringe? You should.),")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("In need of gentleness, like every beast;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Deprive it, and the animal bursts out at last,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Anxious and savage and unable to endure")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Human envy no language to live in.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed47936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781645367314_EPUB-7.vue
// module id = 78
// module chunks = 0